export default __webpack_public_path__ + "static/media/6.dc21ecc7.webp";